// ink-component
import React, { JSXElementConstructor } from 'react';

import Button, { ButtonProps } from '../../../Button/Button';
import Icon from '../../../Icon/Icon';

export interface DropdownTriggerProps extends ButtonProps {
  /** Accepts button components such as `Button`, `HorizontalNavButton` or `SubNavButton` */
  component?: JSXElementConstructor<any>;
  /** The item is marked as active */
  active?: boolean;
  /** Marks the element with a given ID to make it easier to select in tests */
  'data-testid'?: string | number;
  /** Toggles the active state for Dropdown.Trigger */
  activeTrigger?: boolean;
  /** Changes the Dropdown.Trigger visuals, like background and text color */
  type?: ButtonProps['type'];
}

/**
 * @purpose A preset Button to use as the Dropdown 'trigger'
 * @categories navigation
 * @group Dropdown
 * @HTMLType HTMLButtonElement
 */
function DropdownTrigger({
  component: Component = Button,
  type = 'default',
  children,
  'data-testid': dataTestId,
  ...otherProps
}: DropdownTriggerProps) {
  return (
    <Component {...otherProps} type={type} data-testid={dataTestId}>
      {children}&nbsp;
      <Icon type="down-bold" meaning="open dropdown" />
    </Component>
  );
}

DropdownTrigger.defaultProps = {
  component: Button,
};

DropdownTrigger.displayName = 'Dropdown.Trigger';

export default DropdownTrigger;
